export const FrameBackground = {
  DARK: 'hover:bg-neutral-100-opacity-5',
  LIGHT: 'hover:bg-neutral-950-opacity-10',
} as const;

export interface FrameDetailsRendererProps {
  theme?: (typeof FrameBackground)[keyof typeof FrameBackground];
  data?: {
    visualUnitIds?: string[];
  };
}
